export default "__VITE_ASSET__CjDeyXAP__"